import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Bell, CheckCheck } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export default function NotificationsBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const navigate = useNavigate();

  const load = () => api.get("/notifications").then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);

  const readAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <DropdownMenu onOpenChange={(o) => { if (o && data.unread) readAll(); }}>
      <DropdownMenuTrigger asChild>
        <button data-testid="notifications-bell" className="relative h-9 w-9 flex items-center justify-center rounded-xl border border-border bg-card hover:bg-accent transition-colors">
          <Bell className="h-5 w-5" />
          {data.unread > 0 && <span data-testid="notif-unread" className="absolute -top-1 -right-1 h-5 min-w-5 px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">{data.unread}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 max-h-96 overflow-y-auto">
        <div className="flex items-center justify-between px-2 py-1.5">
          <p className="font-semibold text-sm">Notificações</p>
          <button onClick={readAll} className="text-xs text-primary flex items-center gap-1"><CheckCheck className="h-3 w-3" /> Marcar lidas</button>
        </div>
        {data.items.length === 0 ? (
          <p className="text-sm text-muted-foreground px-3 py-6 text-center">Nenhuma notificação ainda.</p>
        ) : data.items.map((n) => (
          <button key={n.id} onClick={() => n.link && navigate(n.link)} data-testid={`notif-${n.id}`}
            className={`w-full text-left px-3 py-2 hover:bg-accent border-t border-border ${!n.read ? "bg-primary/5" : ""}`}>
            <p className="text-sm font-medium">{n.title}</p>
            <p className="text-xs text-muted-foreground">{n.body}</p>
            <p className="text-[10px] text-muted-foreground mt-0.5">{new Date(n.created_at).toLocaleString("pt-BR")}</p>
          </button>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
